import { render, staticRenderFns } from "./EditItemForClients.vue?vue&type=template&id=f229f51e"
import script from "./EditItemForClients.vue?vue&type=script&lang=js"
export * from "./EditItemForClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports